import { tuple } from './type'; // eslint-disable-next-line import/prefer-default-export

export var PresetColorTypes = tuple('pink', 'red', 'yellow', 'orange', 'cyan', 'green', 'blue', 'purple', 'geekblue', 'magenta', 'volcano', 'gold', 'lime');


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/_util/colors.js
// module id = 481
// module chunks = 0